import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-check-submit-bundle-changes',
  imports: [],
  templateUrl: './check-submit-bundle-changes.component.html',
  styleUrl: './check-submit-bundle-changes.component.scss'
})
export class CheckSubmitBundleChangesComponent {
  private activeModal = inject(NgbActiveModal);

  execute() {
    this.activeModal.close({
      submitOrder: true,
    });
  }

  closeModal(canDeactivate: boolean = false) {
    this.activeModal.close({ canDeactivate });
  }
}
